import ApiFigmaIntegration, { FigmaSyncProgressData } from "../api/model/integrations/barrel/FigmaIntegration";

import Model from "./model";

class FigmaIntegration extends Model {
    fileKey?: string;
    fileName?: string;
    isSyncing?: boolean;
    lastSync?: {
        startedAt: Date;
        endedAt: Date;
        exportCounts?: FigmaSyncProgressData;
    };

    constructor(figmaIntegrationData: ApiFigmaIntegration) {
        super();

        const {
            fileKey,
            isSyncing,
            lastSync,
            fileName
        } = figmaIntegrationData;

        this.fileKey = fileKey;
        this.isSyncing = isSyncing;
        this.lastSync = lastSync;
        this.fileName = fileName;
    }
}

export default FigmaIntegration;
